import { createContext } from "react";
import axiosInstance from "../api/axios";

export const VaccineTypeContext = createContext();

async function addVaccineType(formData) {
  const res = await axiosInstance.post("/vaccine-types/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
}

async function getVaccineTypes() {
  const res = await axiosInstance.get("/vaccine-types");
  return res.data; // بيرجع array من الفاكسينز
}

// Remove an VaccineTypes by ID
function removeVaccineTypes(id) {
    return axiosInstance.delete(`/vaccine-types/${id}`)
        .then((response) => response)
        .catch((error) => error);
}

export default function VaccineTypeContextProvider({ children }) {
  return (
    <VaccineTypeContext.Provider value={{ addVaccineType, getVaccineTypes , removeVaccineTypes }}>
      {children}
    </VaccineTypeContext.Provider>
  );
}
